import { Component, ViewEncapsulation, OnInit, Input } from '@angular/core';
import { language, popover, noOp, date } from 'curvy';
import { Task } from '@task-utils/types';
import { TaskRoutes } from '@task-utils/routes';
import { orders_translations } from '../orders.trans';
import { ScheduledOrderTemplateType } from '../orders.types';
import { Order } from '../orders';
import { ScheduledDates } from '@task-components/scheduled-dates';
import { User } from '@task-modules/users/users';
import { WorkHierarchy } from '@task-modules/work-hierarchy';
import { find_child_whier, is_under_whier_id } from '@task-utils/utils';


@Component({
	selector: 'task-scheduled-order-form',
	encapsulation: ViewEncapsulation.None,
	templateUrl: 'scheduled-order-form.component.html',
	styles: [`
		new-scheduled-order-plan task-scheduled-order-form {
			max-width: none;
		}

		new-scheduled-order-plan task-scheduled-order-form .textarea {
			grid-column: auto;
		}

		new-scheduled-order-plan task-scheduled-order-form .field-grid {
			align-items: end;
		}

		@media only screen and (min-width: 1400px) {
			new-scheduled-order-plan task-scheduled-order-form .field-grid {
				grid-template-columns: repeat(4, 1fr);
				grid-gap: 8px 10px;
			}

			new-scheduled-order-plan task-scheduled-order-form .field-grid .grid-el-one {
				grid-column: 1/3;
			}
			new-scheduled-order-plan task-scheduled-order-form .field-grid .grid-el-two-thirds {
				grid-column: -1/3;
			}

		}

		task-edit-scheduled-order-dialog task-scheduled-order-form .field-grid {
			grid-template-columns: 1fr;
		}


		.special-box label,
		label.special-box {
			width: 100%;
			box-sizing: border-box;
			margin-left: 0!important;
			margin-right: 0!important;
		}

		task-scheduled-order-form {
			max-width: 650px;
		}

		@media only screen and (min-width: 600px) {
			task-scheduled-order-form .field-grid {
				min-width: 400px;
				grid-gap: 8px 10px;

			}
		}

		task-scheduled-order-form .field-grid {
			display: grid;
			grid-auto-flow: row;
			grid-template-columns: 1fr 1fr;
			grid-gap: 4px 10px;
		}

		task-scheduled-order-form knw-search-picker {
			display: contents;
		}

		@media only screen and (max-width: 600px) {
			task-scheduled-order-form .field-grid {
				grid-template-columns: 1fr;
			}
		}
	`]
})
export class scheduledOrderFormComponent implements OnInit {

	@Input()
	order: ScheduledOrderTemplateType = Order.scheduled_order_template_empty();

	@Input()
	on_flag_change?: (flag: Task.LabelFlags) => void;

	inventory: Task.KAM_Inventory[] = [];
	descriptions: ScheduledOrderTemplateType["scheduled_orders_template_details"] = [{
		order_detail_type_id: Task.ORDER_DETAIL_TYPE.DESCRIPTION,
		description: ""
	}];



	investment_types = Task.Investment_Type;
	picked_supplier: Task.Supplier = null;
	is_internal_supplier = false;
	picked_worker: Task.User = null;
	yearly_plans = {...Task.Annual_Frequency};
	is_supplier = false;
	is_edit_form = false;
	show_info = false;
	max_date_allowed: Date = null;
	scheduled_order_flags: Task.LabelFlags[] = [];

	update_details() {
		if (this.order.locations.length!==1) {
			this.inventory = [];
			this.order.scheduled_orders_template_details = [...this.descriptions];

		} else {
			this.order.scheduled_orders_template_details = [...this.descriptions, ...this.inventory.map(inv=>({
				order_detail_type_id: Task.ORDER_DETAIL_TYPE.INVENTORY,
				description: "-", // Description is mandatory with order details
				inventory_id: inv.inventory_id,
				inventory_name: inv.inventory_name,
				inventory_no: inv.inventory_no,
				inventory_serial_no: inv.inventory_serial_no,
				inventory_data: inv
			}))];
		}
	}


	ngOnInit() {
		language.load_translations(orders_translations);
		this.init();
	}

	async init() {
		this.is_supplier = await Order.is_supplier_admin();
		this.is_edit_form = this.order["scheduled_orders_template_id"] ? true : false;

		if (this.scheduled_order_flags.length === 0) {
			await this.load_scheduled_order_flags();
		}

		// @TODO(borna): ovdje smo dohvatili podatke o supplieru
		// sa backenda iako bi si ih sami mogli proslijediti iz neke
		// parent componente (create-scheduled-order) ili nešto
		if (this.order.supplier_id) {
			let res = await TaskRoutes.suppliers.api_supplier_get_single(this.order.supplier_id);
			this.picked_supplier = res.data;

			if (this.picked_supplier.supplier_id === (await User.currentUserPromise).company_id) {
				this.is_internal_supplier = true;
			}

			if (this.order.arrival_worker_id) {
				this.picked_worker = this.order.arrival_worker;
				this.is_internal_supplier = true;
			}
		}

		this.descriptions[0].description = this.order.scheduled_orders_template_details.filter(d=>d.order_detail_type_id === Task.ORDER_DETAIL_TYPE.DESCRIPTION)?.[0].description ?? "";


		this.inventory = this.order.scheduled_orders_template_details.filter(d=>d.order_detail_type_id === Task.ORDER_DETAIL_TYPE.INVENTORY).map(d=>d.inventory_data);

	}

	async load_scheduled_order_flags() {
		const res = await TaskRoutes.label_flags.api_label_flags_get_all(User.currentUser.company_id);

		if (res.data) {
			this.scheduled_order_flags = [];

			for (const flag of res.data) {
				if (flag.scheduled_orders && flag.status_id !== Task.LABEL_FLAG_STATUS.DELETED) {

					const is_selected = this.order.label_ids?.includes(flag.label_id!) ?? false;

					this.scheduled_order_flags.push({
						...flag,
						selected: is_selected
					});
				}
			}
		}

		this.order.scheduled_order_flags = this.scheduled_order_flags;
	}

	on_flag_change_internal = (flag: Task.LabelFlags) => {
		if (this.on_flag_change) {
			this.on_flag_change(flag);
		} else {
			if (flag.selected) {
				if (!this.order.label_ids.includes(flag.label_id!)) {
					this.order.label_ids.push(flag.label_id!);
				}
			} else {
				this.order.label_ids = this.order.label_ids.filter(id => id !== flag.label_id);
			}
		}
	}

	show_end_date() {
		return this.order.annual_frequency !== Task.ANNUAL_FREQUENCY.DAILY;
	}

	update_fakturiranje_flag_is_internal() {
		const flag = this.scheduled_order_flags.find(flag => flag.label_id === 27);

		if (flag && this.order.locations.length) {
			if (!this.order.locations[0].internal_tag) {
				flag.selected = true;
			} else {
				flag.selected = false;
			}
			this.on_flag_change_internal(flag);
		}
	}

	async update_fakturiranje_flag_is_whier() {
		if (!this.order.locations.length || !this.order.whier) return;
		const flag = this.scheduled_order_flags.find(flag => flag.label_id === 27);
		if (!flag) return;

		let root = await WorkHierarchy.get_constructed();
		let whier_node = find_child_whier(root, this.order.whier.whier_id);

		let whier_for_fakturiranje = is_under_whier_id(whier_node, [6, 7, 8, 9]);

		if (
			(whier_for_fakturiranje && this.order.locations[0].internal_tag)
			|| (!this.order.locations[0].internal_tag)
		) {
			flag.selected = true;

		} else {
			flag.selected = false;
		}
		this.on_flag_change_internal(flag);
	}

	check_show_info() {
		let is_daily = this.order.annual_frequency === Task.ANNUAL_FREQUENCY.DAILY;
		let has_dates = false;
		let has_freq = !!this.order.annual_frequency;
		if (is_daily) {
			has_dates = !!this.order.planned_start_date;
		} else {
			has_dates = !!this.order.planned_start_date && !!this.order.planned_end_date;
		}

		this.show_info = has_dates && has_freq;

		if (this.order.planned_start_date) {
			if (is_daily) {
				this.order.planned_end_date = this.order.planned_start_date;
			}
			let start_date_parts = date.parts(new Date(this.order.planned_start_date));

			if (this.order.cut_date == null) {
				this.order.cut_date = date.create({
					year: start_date_parts.year,
					month: 11,
					date: 31,
					hour: 12,
					minute: 0,
					second: 0,
					millisecond: 0
				}, false);
			}

			this.max_date_allowed = date.subtract(
				date.create({
					year: start_date_parts.year+1,
					month: start_date_parts.month,
					date: start_date_parts.date,
					hour: 12,
					minute: 0,
					second: 0,
					millisecond: 0
				}, false),
				date.duration({ date: 2 })
			);
		} else this.max_date_allowed = null;
	}

	log(...args: any[]) {
		console.log(...args);
	}

	show_info_popup() {
		popover.open(
			ScheduledDates, noOp, {
				annual_frequency: this.order.annual_frequency,
				start_date: new Date(this.order.planned_start_date),
				end_date: new Date(this.order.planned_end_date),
				cut_date: new Date(this.order.cut_date)
			}, noOp, "mouse", "auto", "info-popover-wrapper"
		);
	}

	select_supp_id(event: Task.Supplier) {
		if (!event) this.order.supplier_id = null;
		else this.order.supplier_id = event.supplier_id;

		if (event.company_type_id === Task.COMPANY_TYPE.MAIN) {
			this.is_internal_supplier = true;
		} else {
			this.is_internal_supplier = false;
			this.order.arrival_worker = null;
			this.order.arrival_worker_id = NaN;
		}
	}

	select_whier_id(event: Task.WorkHierarchy) {
		if (!event) this.order.whier_id = null;
		else this.order.whier_id = event.whier_id;
	}


	search_suppliers = async (search: string) => {
		let res = await TaskRoutes.suppliers.api_supplier_search(
			{ attributes: ["company.name"], search: [search]},
			{page_no: 1, page_size: 15}
		);

		return res.data;
	}

	format_supplier_name(supp: Task.Supplier) {
		if (!supp) { return ""; }
		return supp.name;
	}

	search_workers = async (search: string) => {
		let res = await TaskRoutes.users.api_user_search({
			search: [search, `${Task.USER_TYPE.COMPANY_WORKER}`],
			attributes: ['first_name+ +last_name', "#=:user_type_id"]
		}, {
			page_no: 1,
			page_size: 100
		})


		return res.data.sort((a,b)=>{
			return a.last_name.localeCompare(b.last_name);
		});
	}

	format_worker_name(usr: Task.User) {
		if (!usr) return "";
		return `${usr.first_name} ${usr.last_name}`
	}

	select_picked_worker(worker: Task.User) {
		if (worker) {
			this.order.arrival_worker = worker;
			this.order.arrival_worker_id = worker.user_id;
		} else {
			this.order.arrival_worker = null;
			this.order.arrival_worker_id = NaN;
		}
	}
}

